import React from 'react';
import { OverlayView } from '@react-google-maps/api';
import styled from 'styled-components/macro';


const LocationInfo = ({ location }) => {
    if (location) {
        const overlayProps = {
            position:    location.acf.position,
            mapPaneName: OverlayView.OVERLAY_MOUSE_TARGET,
        };
        
        overlayProps.getPixelPositionOffset = (width, height) => ({
            x: -(width / 2),
            y: 20
        });
        
        return (
            <OverlayView {...overlayProps}>
                <Wrapper>
                    <Container>
                        <Name dangerouslySetInnerHTML={{ __html: location.title.rendered }}/>
                        
                        {location.acf.description && (
                            <Description dangerouslySetInnerHTML={{ __html: location.acf.description }}/>
                        )}
                    </Container>
                </Wrapper>
            </OverlayView>
        );
    } else {
        return <div/>;
    }
};


export default LocationInfo;


const Wrapper = styled.div`
    padding-top: 8px;
`;

const Container = styled.div`
    position: relative;
    padding: 12px 16px;
    background-color: ${props => props.theme.app_background};
    box-shadow: 2px 2px 15px rgba(0,0,0,.2);
    
    font-family: basic-sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 1em;
    white-space: nowrap;
    letter-spacing: .08em;
    text-transform: uppercase;
    
    &:after {
        display: block;
        content: "";
        position: absolute;
        bottom: 100%;
        left: 50%;
        height: 0;
        width: 0;
        pointer-events: none;
        margin-left: -8px;
        
        border-style: solid;
        border-color: transparent;
        border-bottom-color: ${props => props.theme.app_background};
        border-width: 8px;
    }
`;

const Name = styled.div`
    text-transform: uppercase;
    font-weight: 700;
`;

const Description = styled.div`
    padding-top: 4px;
`;
